/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FlipHorizontalIcon
 */
export default class FlipHorizontalIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><g fillRule="nonzero"><path d="M8.92 8c-.977 0-1.87.52-2.307 1.345l-4.84 9.133c-.637 1.202-.12 2.664 1.154 3.265.358.169.753.257 1.153.257h4.84c1.425 0 2.58-1.09 2.58-2.434v-9.132C11.5 9.09 10.345 8 8.92 8zm.053 2c.259 0 .474.17.519.395l.008.087v9.036c0 .237-.186.433-.432.474L8.973 20H4.027a.568.568 0 01-.235-.05.468.468 0 01-.271-.566l.035-.081L8.5 10.266A.534.534 0 018.973 10zM15.08 8c.977 0 1.87.52 2.307 1.345l4.84 9.133c.637 1.202.12 2.664-1.154 3.265A2.707 2.707 0 0119.92 22h-4.84c-1.425 0-2.58-1.09-2.58-2.434v-9.132C12.5 9.09 13.655 8 15.08 8zm-.053 2c-.259 0-.474.17-.519.395l-.008.087v9.036c0 .237.186.433.432.474l.095.008h4.946a.568.568 0 00.235-.05.468.468 0 00.271-.566l-.035-.081-4.945-9.037a.534.534 0 00-.472-.266z"/><path d="M19.429 2.275a1 1 0 011.322-.05l.092.086 1.882 1.98.079.093a1 1 0 01-.012 1.206l-.081.092-2 2.021-.093.084a1.001 1.001 0 01-1.226.007l-.095-.083-.084-.094a1 1 0 01-.007-1.226l.083-.094.293-.297H4.416l.294.297a1 1 0 01.076 1.32l-.084.094a1 1 0 01-1.32.076l-.094-.084-1.999-2.02a1 1 0 01-.093-1.299l.08-.094 1.88-1.979a1 1 0 011.53 1.282l-.08.096L4.308 4H19.69l-.297-.311-.08-.096a1 1 0 01.116-1.318z"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

